export const SERVER_API = "https://api-prod.villagefranco.prod-projet.com/";
export const REGISTER_API = "auth/register";
export const USER_DETAIL = "users/";
export const QUESTION_ID = "questions/";
export const ANSWER = "answers/question/";
export const TOTAL = "questions/total";
export const QUEST_TAB = "questions/random/event/";
export const ACTIVE_EVENT = "events/active/true"
